export const IFRAME_CTN_ID = 'iframe-ctn';
export const CODEMIRROR_CTN_ID = 'codemirror-ctn';
export const IFRAME_CODEMIRROR_BTN_CTN_CLASS = 'iframe-codemirror-buttons';
export const RESET_BUTTON_SELECTOR = `.${IFRAME_CODEMIRROR_BTN_CTN_CLASS} > nw-button`;
export const BTN_PRIMARY = 'div > button.btn-primary';
export const DEFAULT_ESCAPE_KB_TRAP_SHORTCUT = 'Ctrl-Q';
